export default __webpack_public_path__ + "static/media/charts.5b4673c9.svg";